import { useMap } from '@vis.gl/react-google-maps';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect } from 'react';

import { getBoundsFromPoints } from '@/utils';
import CenterMapIcon from 'assets/CenterMapIcon';

import { MapControlButton, MapControlButtonContainer } from '../../Map.styles';

const CenterControl = ({ center, defaultZoom, paths }) => {
  const map = useMap();

  const handleCenterMap = useCallback(() => {
    if (!map) return;

    if (paths) {
      const bounds = getBoundsFromPoints(paths);
      if (bounds) {
        map.fitBounds(bounds);
      }
    } else {
      map.panTo(center);
      map.setZoom(defaultZoom);
    }
  }, [map, center, defaultZoom, paths]);

  useEffect(() => {
    handleCenterMap();
  }, [handleCenterMap]);

  return (
    <MapControlButtonContainer>
      <MapControlButton onClick={handleCenterMap}>
        <CenterMapIcon />
      </MapControlButton>
    </MapControlButtonContainer>
  );
};

CenterControl.propTypes = {
  center: PropTypes.object.isRequired,
  defaultZoom: PropTypes.number.isRequired,
  paths: PropTypes.array,
};

export default CenterControl;
